export default {"src":"/_next/static/media/chevron-down.91185aa3.svg","height":24,"width":24};